/* unplugin-vue-components disabled */import { render } from "./typebtn.vue?vue&type=template&id=ba2062f0&scoped=true"
import script from "./typebtn.vue?vue&type=script&lang=js"
export * from "./typebtn.vue?vue&type=script&lang=js"

import "./typebtn.vue?vue&type=style&index=0&id=ba2062f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba2062f0"]])

export default __exports__